export const INFO = {
  NOTHING_CHANGE: "Nothing has changed !",
};
